// extracted by mini-css-extract-plugin
export default {"root":"TreetShopNavBar_root__xU9e9","logo":"TreetShopNavBar_logo__2htUZ"};